export enum TimeRecordType {
  in = 1,
  out = 2
}
